export default "__VITE_ASSET__CE14_4eE__"